let __awaiter =
  (this && this.__awaiter) ||
  function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function(resolve) {
            resolve(value)
          })
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value))
        } catch (e) {
          reject(e)
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value))
        } catch (e) {
          reject(e)
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected)
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next())
    })
  }
function handleClose() {
  return __awaiter(this, void 0, void 0, function*() {
    // After change callback - global
    if (this._globalBeforeExitCallback)
      try {
        yield this._globalBeforeExitCallback()
      } catch (e) {
        return
      }
    this.dialog.style.display = 'none'
    this.backdrop.style.display = 'none'
    this.isVisible = false
    if (!this.options.rememberStep) this.activeStep = 0
    if (this.options.debug) console.info('Tour exited')

    console.info('Marking tour as complete on local storage (handleClose)')

    if (!localStorage.tg_tours_complete) {
      localStorage.tg_tours_complete = [this.group]
    } else {
      const storageTours = localStorage.tg_tours_complete.split(',')
      storageTours.push(this.group)
      localStorage.tg_tours_complete = storageTours
    }

    console.info(
      'Successfully marked tour as complete on local storage (handleClose)'
    )

    yield this.destroyListeners()
    setTimeout(() => {
      if (this._globalAfterExitCallback) this._globalAfterExitCallback()
    }, 0)
    return
  })
}
export default handleClose
